<template>
  <b-modal
    v-model="editorShown"
    title="Request Document Package"
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
    size="md"
    centered
    no-close-on-backdrop
    @ok.prevent="submitForm"
  >
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="secondary" @click="cancel">
        Cancel
      </b-button>
      <b-button variant="primary" @click="ok">
        Save
      </b-button>
    </template>
    <b-row>
      <b-col>
        <b-form-group
          label="Account"
          :state="formErrors.portalAccount.length == 0 ? null : false"
          :invalid-feedback="formErrors.portalAccount.join(', ')"
        >
          <v-select
            v-model="form.portalAccount"
            :options="portalAccounts"
          ></v-select>
        </b-form-group>
        <b-form-group
          label="Document Package"
          :state="formErrors.package.length == 0 ? null : false"
          :invalid-feedback="formErrors.package.join(', ')"
        >
          <v-select v-model="form.package" :options="sharePackages"></v-select>
        </b-form-group>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from "vuex";
import portalAccessServer from "../../../server/portalAccess";
import portalDocumentServer from "../../../server/portalDocument";
import { validateRequired } from "../../../helpers/validation";

export default {
  name: "SharePackageModal",
  props: ["eocId", "patientId"],
  data() {
    return {
      portalAccounts: [],
      form: {
        portalAccount: null,
        package: null
      },
      formErrors: {
        portalAccount: [],
        package: []
      }
    };
  },
  mounted() {
    this.fetchPortalAccounts();
    this.fetchSharePackages();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("client", ["fetchSharePackages"]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    async fetchPortalAccounts() {
      const portalAccounts = await portalAccessServer.findAllAccess(
        this.patientId
      );
      this.portalAccounts = portalAccounts.map(access => ({
        value: access.id,
        label: `${access.name} (${access.relationship})`
      }));
    },
    async submitForm() {
      if (!this.validateForm()) {
        return;
      }

      const formData = {
        sharePackageId: this.form.package.value,
        portalAccessId: this.form.portalAccount.value,
        patientId: this.patientId,
        episodeOfCareId: this.eocId
      };

      await portalDocumentServer.shareDocumentPackage(formData);

      this.$emit("onModify");
    },
    validateForm() {
      let withoutErrors = true;

      this.formErrors.portalAccount = [];
      if (!validateRequired(this.form.portalAccount)) {
        this.formErrors.portalAccount.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.package = [];
      if (!validateRequired(this.form.package)) {
        this.formErrors.package.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    }
  },
  computed: {
    ...mapState("client", {
      sharePackages: state =>
        state.sharePackages.map(s => ({
          value: s.id,
          label: s.name,
          data: s
        }))
    }),
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>

<style></style>
